<div class="demo-banner" role="status">
  <span class="demo-banner-tag">
    <nz-icon nzType="experiment" nzTheme="outline"></nz-icon>
    演示环境
  </span>

  <span class="demo-banner-text">
    这里的数据是为演示编造的，<strong>不是真实投放</strong>；所有访客共用同一份数据，
    你的改动其他人也看得见。
  </span>

  @if (errorMessage()) {
    <span class="demo-banner-error">{{ errorMessage() }}</span>
  }

  <button
    nz-button
    nzSize="small"
    class="demo-banner-reset"
    [nzLoading]="resetting()"
    (click)="reset()"
  >
    重置演示数据
  </button>
</div>
